/**
 * Route for `bonus-structure-display-for-partners`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { BonusStructureDisplayForPartnersPage } from "../features/bonus-structure-display-for-partners/BonusStructureDisplayForPartnersPage";

export const bonusStructureDisplayForPartnersRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/bonus-structure-display-for-partners",
	component: BonusStructureDisplayForPartnersPage,
});

export default bonusStructureDisplayForPartnersRoute;
